// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_3o-2";
export var blackBorderOnHover = "_3o-7";
export var cell = "_3o-6";
export var cellContainer = "_3o-3";
export var checked = "_3o-8";
export var disabled = "_3o-5";
export var featuredIconCellContainer = "_3o-9";
export var featuredIconTextContainer = "_3o-b";
export var featuredIconWrapper = "_3o-a";
export var noBorder = "_3o-c";
export var orangeSelectedRow = "_bj-3";
export var overflowableText = "_3o-0";
export var overflowableTextContainer = "_3o-1";
export var row = "_3p-0";
export var rowCheckboxCell = "_3o-4";
export var selectableTable = "_bj-2";